<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      addText=""
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>sku名称:</label>
            <lk-input
              clearable
              :maxlength='50'
              class="item"
              v-model="query.skuName"
              placeholder='请输入sku名称'
            ></lk-input>
          </div>
          <div class="queryItem" >
            <goodsSearchItem
              :placeholder='placeholder'
              v-model="query.nameMix"
              :maxlength='50'
              labelString='商品信息'
            ></goodsSearchItem>
         </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btn-wrap">
          <lk-button v-if="this.handlePermission('thirdPartyAdd')" class="mb8" type="primary" icon='md-add'  @click="addNew">添加</lk-button>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import thirdParty from '@/services/thirdParty';
import utils from '@/libs/utils';
import goodsSearchItem from '@/components/goodsSearchItem.vue';
import mapState from '@/mixins/mapState';
import queryMixins from '@/mixins/queryMixins';

export default {
  name: 'ThirdPartyManagement',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    goodsSearchItem,
  },
  data() {
    return {
      placeholder: '支持商品编码、通用名、商品名',
      query: {
        skuName: '',
      },
      columns: [
        {
          title: '序号',
          minWidth: 58,
          align: 'center',
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '三方平台',
          minWidth: 116,
          key: 'type',
          render: (h, { row }) => h('div', this.thirdPartyName(row.type)),
        },
        {
          title: '三方商品编码',
          minWidth: 116,
          key: 'skuId',
        },
        {
          title: 'sku名称',
          minWidth: 136,
          key: 'skuName',
        },
        {
          title: '基础商品编码',
          minWidth: 116,
          key: 'serialCode',
        },
        {
          title: '通用名称',
          minWidth: 136,
          key: 'approvedDrugNames',
        },
        {
          title: '商品名称',
          minWidth: 140,
          key: 'goodsName',
        },
        {
          title: '生产企业',
          minWidth: 146,
          key: 'manufacturer',
        },
        {
          title: '包装规格',
          minWidth: 136,
          key: 'specifications',
        },
        {
          title: '转换比例',
          minWidth: 100,
          key: 'num',
        },
        {
          title: '创建人',
          minWidth: 116,
          key: 'createUserName',
        },
        {
          title: '创建时间',
          minWidth: 150,
          key: 'createTime',
        },
        {
          title: '操作',
          minWidth: 116,
          fixed: 'right',
          render: (h, { row }) => h('div', [
            this.handlePermission('thirdPartyEdit') ? h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'thirdPartyEdit', params: { id: row.skuId, operateType: 2 } });
                },
              },
            }, '编辑') : null,
          ]),

        },
      ],
      tableData: [],
    };
  },
  methods: {
    thirdPartyName(type) {
      if (type) {
        return this.publicParams.thirdParty.filter(item => item.type === type)[0].name;
      }
      return '';
    },
    clear() {
      this.page = 1;
      this.size = 20;
      this.query = {
        skuName: '',
      };
    },
    addNew() {
      this.$router.push({ name: 'thirdPartyAdd', params: { operateType: 1 } });
    },
    // handleSearch() {
    //   this.getData();
    // },
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      thirdParty.getThirdPartyList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = item;
            item.createTime = utils.formatDateToSecond(item.createTime);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
